import styled from '@emotion/styled'

export const ProgressBarWrapper = styled.div`
  width: 294px;
`
